import { ArrowUpRight, BadgeCheck, Mail, MessageCircle } from "lucide-react";
import { LeadForm } from "./LeadForm";
import { MaskedLine, Reveal } from "./Reveal";
import { Magnetic } from "./Magnetic";
import { Sparkle } from "./Sparkle";
import { WA_DEMO, BRAND, TRUST_LINES } from "../../lib/site";

export const FinalCta = () => (
  <section id="contact" data-testid="final-cta-section" className="relative py-24 sm:py-36 overflow-hidden scroll-mt-20" aria-label="Start your project">
    <div className="glow-orb w-[800px] h-[800px] -top-64 left-1/2 -translate-x-1/2 opacity-80" />
    <Sparkle className="absolute top-24 left-[10%]" size={18} />
    <Sparkle className="absolute bottom-32 right-[8%]" size={14} fast />

    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-start">
      <div>
        <Reveal y={18}>
          <p className="eyebrow mb-6" data-testid="final-cta-eyebrow">Final Call</p>
        </Reveal>
        <h2 className="font-display font-light tracking-tight text-white text-4xl sm:text-6xl lg:text-7xl leading-[1.0]" data-testid="final-cta-headline">
          <MaskedLine delay={0.05}>Ready to look</MaskedLine>
          <MaskedLine delay={0.17}>this good <em className="italic text-shimmer">online?</em></MaskedLine>
        </h2>
        <Reveal delay={0.3}>
          <p className="mt-7 text-mute text-base sm:text-lg leading-relaxed max-w-md">
            Tell us about your business. We&apos;ll reply on WhatsApp — and if we&apos;re a fit,
            your free custom demo is next. No sales pitch, no pressure.
          </p>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-8 space-y-3">
            {TRUST_LINES.map((t) => (
              <p key={t} className="inline-flex items-center gap-2.5 text-sm text-mute mr-6">
                <BadgeCheck size={16} className="text-brand" /> {t}
              </p>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.5}>
          <div className="mt-9 flex flex-col gap-4">
            <Magnetic>
              <a
                data-testid="final-cta-whatsapp-button"
                href={WA_DEMO}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 pl-6 pr-1.5 py-1.5 border border-brand/60 text-white text-sm font-semibold w-fit hover:bg-brand/5 transition-colors duration-300"
              >
                <MessageCircle size={16} className="text-brand" />
                Or skip the form — WhatsApp us now
                <span className="btn-arrow-box"><ArrowUpRight size={15} /></span>
              </a>
            </Magnetic>
            <a
              data-testid="final-cta-email-link"
              href={`mailto:${BRAND.email}`}
              className="inline-flex items-center gap-2.5 text-mute hover:text-brand text-sm transition-colors duration-300 w-fit"
            >
              <Mail size={15} /> {BRAND.email}
            </a>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.25}>
        <div className="bg-panel border hairline p-7 sm:p-10 relative" data-testid="final-cta-form-card">
          <span className="absolute -top-px left-10 w-16 h-px bg-brand" aria-hidden="true" />
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-brand mb-2">Project Enquiry</p>
          <h3 className="font-display text-2xl sm:text-3xl text-white font-medium mb-7">Start your project</h3>
          <LeadForm />
        </div>
      </Reveal>
    </div>
  </section>
);
